import type { PaymentStatus } from './api';

/** `payment-receipts/spec.md`: no internal code is ever shown to the user, only its Spanish label. */
export const PAYMENT_STATUS_LABELS: Record<PaymentStatus, string> = {
  RECORDED: 'Registrado',
  CLEARED: 'Imputado',
  VOIDED: 'Anulado',
};
